import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
  name: 'trailer',
  initialState: {

  },
  reducers: {
    startTrailer: state => {
      // Does nothing it's a cheat
    }
  },
});

export const { startTrailer } = slice.actions;

// export const selectAlertOverlayData = state => state.overlay.alertData;

export default slice.reducer;
